import { AfterViewInit, Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AssociationsService } from 'app/services/associations.service';
import { Alert } from 'app/shared/alerts/simple-message/simple-message.component';
import { AssociationHelper } from 'app/storage/association.storage';
import { MeetingFormService } from '../../meeting-form.service';
import { collectFieldErrors, FieldError, focusAndScrollToField } from 'app/shared/forms/form-validation.util';

const FIELD_LABELS: {[key: string]: string} = {
  date: 'Meeting date',
  dateSetted: 'Meeting date confirmation',
  meetingCompleted: 'Meeting completion confirmation',
}

@Component({
  selector: 'date-setted',
  templateUrl: './date-setted.component.html',
  styleUrls: ['../../meeting-form.component.scss', '../form-steps.scss', './date-setted.component.scss']
})
export class DateSettedComponent implements OnInit {


  showAlert: boolean = false
  alertMessage: string = ''
  alertType: Alert = Alert.SUCCESS

    meetingsOrder = [
      'first', 'second', 'third', 'advice', "final"
    ]

    MEETING_FORM: number = 0

    accepted: boolean = false
    form : FormGroup

    submitted: boolean = false
    fieldErrors: FieldError[] = []

  constructor(
    private service: MeetingFormService,
    private mongoService: AssociationsService,
    private helper: AssociationHelper,
    private router: Router,
    private formBuilder: FormBuilder,
    private hostRef: ElementRef,
  ) {
    this.form = service.getForm()
    this.MEETING_FORM = this.helper.getMeetingForm()
   }

  ngOnInit(): void {
    //this.form = this.formBuilder.group({
      //date: ['', Validators.required] // Add required validation to the date field
    //});
  }

  getIndex(): number{
    return this.MEETING_FORM > 0 ? this.MEETING_FORM - 1 : 0
  }

  accept(accept: boolean): void{
    this.form.patchValue({
        dateSetted: accept
    })
    this.accepted = accept
    !accept ? this.addAlert(`Please contact project to arrange ${this.meetingsOrder[this.getIndex()]} meeting.`, Alert.ERROR) : null
  }

  confirm(): void{
    this.submitted = true
    const fields: FieldError[] = Object.keys(this.form.controls).map(key => ({ key, label: FIELD_LABELS[key] || key }))
    this.fieldErrors = collectFieldErrors(this.form, fields)
    if(this.fieldErrors.length){
      focusAndScrollToField(this.hostRef.nativeElement, this.fieldErrors[0].key)
      return
    }

    let meeting = this.MEETING_FORM
    if(meeting <= 0){
      meeting = 1
    }

    this.mongoService.submitForm(
      this.helper.getSelectedProject(),
      this.helper.getSelectedEpe(),
      this.service.getSubmitMeetingValue(meeting),
      this.service.getSubmit(),
      false,
      false
      ).subscribe(
        () => {
          this.router.navigateByUrl(`form/(meeting-form:meeting_${meeting}/(meeting_${meeting}:${this.service.getNextStep()}))`)
        }
      )
  }

  addAlert(message: string, type: Alert){

    this.alertMessage = message
    this.alertType = type
    this.showAlert = true

  }

  jumpToField(key: string): void {
    focusAndScrollToField(this.hostRef.nativeElement, key)
  }

}
